import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { CampaignInterface } from '../../../../interfaces/campaigns/campaign.interface';
import { GroupInterface } from '../../../../interfaces/groups/group.interface';
import { GroupsService } from '../../../../services/groups/groups.service';
import { MarketingCampaignsService } from '../../../../services/marketing-campaigns/marketing-campaigns.service';
import { UiAlertService } from '../../../../services/ui-alert/ui-alert.service';
import {
  MarketingCampaignCreateComponent
} from '../../modals/marketing-campaign-create/marketing-campaign-create.component';
import { MarketingCampaignEditComponent } from '../../modals/marketing-campaign-edit/marketing-campaign-edit.component';
@Component({
  selector: 'app-marketing-campaigns-list',
  templateUrl: './marketing-campaigns-list.component.html',
  styleUrls: ['./marketing-campaigns-list.component.scss']
})
export class MarketingCampaignsListComponent implements OnInit {

  columnNames = ['name', 'channel', 'status', 'groupNames', 'actionmenu'];
  tableDataSource = new MatTableDataSource<any>();

  groups: GroupInterface[] = [];
  campaignCount = 0;

  constructor(
    private marketingCampaignsService: MarketingCampaignsService,
    private groupsService: GroupsService,
    private uiAlertService: UiAlertService,
    private snackBar: MatSnackBar,
    public utilsService: UtilsService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.load();
  }

  async play(campaign: CampaignInterface): Promise<void> {
    const { count }: { count: number} = await this.marketingCampaignsService.getTargetCount(campaign.id);
    if (count === 0) {
      this.snackBar.open('No targets to send this campaign.', '', { duration: 2000 });
      return;
    }
    const ok = await this.uiAlertService.presentAlertConfirm(
      `Do you really want to start this campaign? It will be sent to ${count} target${count === 1 ? '' : 's'}. 
      This action cannot be undone. Do you want to continue?`
    );
    if (ok) {
      try {
        await this.marketingCampaignsService.runById(campaign.id);
        this.snackBar.open('Campaign started successfully.', '', { duration: 2000 });
      } catch (error) {
        this.snackBar.open(
          'Error while starting this Campaign. Try again in a few minutes.',
          '',
          { duration: 2000 }
        );
      } finally {
        this.load();
      }
    }
  }

  load(): void {
    this.marketingCampaignsService.getAll().then(campaigns => {
      this.campaignCount = campaigns.length;
      this.tableDataSource.data = campaigns.map(
        (c) => {
          return {
            ...c,
            groupNames: c.groups.map(g => g.name).join(', ')
          }
        }
      );
    });
    this.groupsService.getAll().then(groups => {
      this.groups = groups;
    });
  }

  add(): void {
    const dialogRef = this.dialog.open(MarketingCampaignCreateComponent, {
      data: { groups: this.groups }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.save) {
        this.snackBar.open('Campaign created.', '', { duration: 2000 });
        this.load();
      }
    });
  }

  edit(campaign: CampaignInterface): void {
    const dialogRef = this.dialog.open(MarketingCampaignEditComponent, {
      data: { campaign, groups: this.groups }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.updated) {
        this.snackBar.open('Campaign updated.', '', { duration: 2000 });
        this.load();
      }
    });
  }

  // async remove(item: any): Promise<void> {
  //   const ok = await this.uiAlertService.presentAlertConfirm(
  //     'Do you really want to remove this campaign?');
  //   if (ok) {
  //     try {
  //       await this.marketingCampaignsService.removeById(item.id);
  //       this.snackBar.open('Campaign removed successfully.', '', { duration: 2000 });
  //     } catch (error) {
  //       console.error(error);
  //       this.snackBar.open('Error while removing this Campaign. Try again in a few minutes.', '', { duration: 2000 });
  //     } finally {
  //       this.load();
  //     }
  //   }
  // }

  async clone(item: any): Promise<void> {
    const ok = await this.uiAlertService.presentAlertConfirm(
      'Do you really want to clone this campaign?');
    if (ok) {
      try {
        await this.marketingCampaignsService.cloneById(item.id);
        this.snackBar.open('Campaign duplicated successfully.', '', { duration: 2000 });
      } catch (error) {
        console.error(error);
        this.snackBar.open(
          'Error while duplicated this Campaign. Try again in a few minutes.',
          '',
          { duration: 2000 }
        );
      } finally {
        this.load();
      }
    }
  }
}
